import React, { Component } from "react";
import { render } from "react-dom";
import { StaticMap } from "react-map-gl";
import DeckGL from "@deck.gl/react";
import { Tile3DLayer } from "@deck.gl/geo-layers";

import { registerLoaders } from "@loaders.gl/core";
// To manage dependencies and bundle size, the app must decide which supporting loaders to bring in
import { DracoWorkerLoader } from "@loaders.gl/draco";
import { CesiumIonLoader } from "@loaders.gl/3d-tiles";

registerLoaders([DracoWorkerLoader]);

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiZGdpbnRlcmFjdGl2ZSIsImEiOiJja3JwNW5zcDIyNHI5MnZvYmc1cXAyZDJyIn0.BkT_L2NE7BjevwqCYrIm1Q"; // Set your mapbox token here
const ION_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIwOWU0MGVmYi1kYTlkLTRhMjktYWQ4Ni05NGRjZTExZWYxNDYiLCJpZCI6MzA0NDQsImlhdCI6MTYyNzU3NzIyOH0.1u70ZcuBamWO_iVHHhxyklI3ts_3lm-avVetFOy6UhY"; // Set your ion token here
const ION_ASSET_ID = "542394"; // Set your ion token here

const TILESET_URL = `https://assets.cesium.com/${ION_ASSET_ID}/tileset.json`;

const INITIAL_VIEW_STATE = {
  latitude: 40,
  longitude: -75,
  pitch: 45,
  maxPitch: 60,
  bearing: 0,
  minZoom: 2,
  maxZoom: 18,
  zoom: 15
};

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialViewState: INITIAL_VIEW_STATE
    };
  }

  // Recenter view to cover the new tileset, with a fly-to transition
  _centerViewOnTileset(tileset) {
    const { cartographicCenter, zoom } = tileset;
    this.setState({
      initialViewState: {
        ...INITIAL_VIEW_STATE,

        // Update deck.gl viewState, moving the camera to the new tileset
        longitude: cartographicCenter[0],
        latitude: cartographicCenter[1],
        zoom: INITIAL_VIEW_STATE.zoom,
        bearing: INITIAL_VIEW_STATE.bearing,
        pitch: INITIAL_VIEW_STATE.pitch
      }
    });
  }

  _renderTile3DLayer() {
    return new Tile3DLayer({
      id: "tile-3d-layer",
      pointSize: 2,
      data: TILESET_URL,
      loader: CesiumIonLoader,
      loadOptions: { "cesium-ion": { accessToken: ION_TOKEN } },
      onTilesetLoad: this._centerViewOnTileset.bind(this)
    });
  }

  render() {
    const { initialViewState } = this.state;
    const tile3DLayer = this._renderTile3DLayer();
    const {
      mapStyle = "mapbox://styles/dginteractive/ckrnugi1h54b718qpglc7dqfw"
    } = this.props;

    return (
      <div>
        <DeckGL
          layers={[tile3DLayer]}
          initialViewState={initialViewState}
          controller={true}
        >
          <StaticMap
            mapStyle={mapStyle}
            mapboxApiAccessToken={MAPBOX_TOKEN}
            preventStyleDiffing
          />
        </DeckGL>
      </div>
    );
  }
}
